import { render, staticRenderFns } from "./PropostaAvalistaEdit.vue?vue&type=template&id=85cb4f6a"
import script from "./PropostaAvalistaEdit.vue?vue&type=script&lang=js"
export * from "./PropostaAvalistaEdit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports